import React from 'react';
import styled from 'styled-components';
import { classic } from '~/themes';

type IProps = {
  color: 'primary' | 'secondary' | 'white' | 'transparent';
  textColor?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  disabled?: boolean;
  hidden?: boolean;
  type?: 'button' | 'submit' | 'reset';
  opaque?: boolean;
  width?: string;
  minWidth?: string;
  minHeight?: string;
  withoutIconMargin?: boolean;
  textTransform?: string;
  ref?: any;
  margin?: string;
};

export default function Button({
  color,
  textColor,
  onClick,
  children,
  disabled,
  minHeight,
  hidden,
  type,
  opaque,
  width,
  minWidth,
  withoutIconMargin,
  textTransform,
  margin,
  ref,
}: IProps) {
  return (
    <Container
      color={color}
      disabled={disabled}
      hidden={hidden}
      $minWidth={minWidth}
      onClick={onClick}
      opaque={opaque}
      ref={ref}
      $textColor={textColor}
      textTransform={textTransform}
      type={type}
      width={width}
      withoutIconMargin={withoutIconMargin}
      $margin={margin}
      $minHeight={minHeight}
    >
      {children}
    </Container>
  );
}

const Container = styled.button<{
  color: 'primary' | 'secondary' | 'white' | 'transparent';
  disabled?: boolean;
  hidden?: boolean;
  $textColor?: string | 'white';
  opaque?: boolean;
  width?: string;
  $minWidth?: string;
  $minHeight?: string;
  withoutIconMargin?: boolean;
  textTransform?: string;
  $margin?: string;
}>`
  align-items: center;
  border-radius: 12px;
  box-shadow: ${({ color }) => {
    if (color === 'transparent') return 'none';
    return ` inset 0 2px 2px 0 rgba(255, 255, 255, 0.35),
    inset 0 -2px 2px 0 rgba(0, 0, 0, 0.4),
    0 3px 4px 0 rgba(0, 0, 0, 0.25)`;
  }};

  background-color: ${({ color }) => {
    if (color === 'primary') return `${classic.token?.colorPrimary}`;
    if (color === 'secondary') return `${classic.token?.colorTextSecondary}`;
    if (color === 'transparent') return 'transparent';

    return '#ccecf3';
  }};
  color: ${({ $textColor }) =>
    $textColor ? $textColor : `${classic.token?.colorWhite}`};
  cursor: pointer;
  display: ${({ hidden }) => (hidden ? 'hidden' : 'flex')};
  flex-direction: row;
  min-height: ${({ $minHeight }) => $minHeight ?? '42px'};
  min-width: ${({ $minWidth }) => $minWidth ?? '0'};
  font-size: 1.25rem;
  font-weight: 700;
  justify-content: center;
  letter-spacing: normal;
  margin: ${({ $margin }) => ($margin ? $margin : '0')};
  opacity: ${({ disabled, hidden }) => {
    if (hidden) return 0;
    if (disabled) return 0.5;

    return 1;
  }};
  padding: 8px 30px;
  pointer-events: ${({ disabled, hidden }) =>
    disabled ?? hidden ? 'none' : 'auto'};
  text-transform: ${({ textTransform }) => textTransform ?? 'uppercase'};
  transition: all 0.6s linear;
  visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
  width: ${({ width }) => width ?? '200px'};
  @media screen and (max-height: 415px) {
    height: 30px;
    font-size: 1rem;
  }
  @media screen and (max-height: 900px) {
    font-size: 1.15rem;
  }
  @media screen and (max-width: 700px) {
    font-size: 0.95rem;
  }
  @media screen and (max-height: 700px) {
    font-size: 0.95rem;
  }
  @media screen and (max-width: 415px) {
    font-size: 1rem;
    padding: 8px 14px;
  }

  @media screen and (max-height: 415px) {
    font-size: 1rem;
  }

  @media screen and (max-width: 667px) {
    padding: 8px 14px;
  }
  @media screen and (max-height: 600px) {
    padding: 8px 14px;
  }

  &:focus {
    background-color: ${({ color }) => {
      if (color === 'primary') return `${classic.token?.colorPrimaryBgHover}`;
      if (color === 'secondary')
        return `${classic.token?.colorBorderSecondary}`;

      return '#ccecf3';
    }};
    font-weight: bold;
    outline: 0;
  }

  &:hover {
    background-color: ${({ color }) => {
      if (color === 'primary') return `${classic.token?.colorPrimaryBgHover}`;
      if (color === 'secondary')
        return `${classic.token?.colorBorderSecondary}`;

      return '#ccecf3';
    }};
  }
`;

/*
 &:hover {
    background-color: ${({ color }) =>
      color === 'primary' ? `transparent` : '#af501d'};
    color: ${({ textColor, theme }) => {
      if (textColor) {
        if (textColor === 'white') return `${theme.palette.common.white}`;

        return textColor;
      }

      return '#000000';
    }};
  }

   &:focus {
    background-color: ${({ color }) =>
      color === 'white' ? `transparent` : '#af501d'};
    color: ${({ textColor, theme }) => {
      if (textColor) {
        if (textColor === 'white') return `${theme.palette.common.white}`;

        return textColor;
      }

      return '#000000';
    }};
  }s
*/
